import { NgModule } from "@angular/core";
import { mapToCanActivate, RouterModule, Routes } from "@angular/router";
import { AuthInterceptorPage } from "./auth-interceptor/auth-interceptor.component";
import { AuthInterceptorGuard } from "./auth-interceptor/auth-interceptor.guard";
import { ComponentsComponent } from "./components/components.component";
import { LoggedInGuard } from "./t1-workspace/guards/logged-in.guard";
import { FeedsGuard, NavigatedFor } from "./t1-workspace/guards/navigation-check.guard";
import { NavigationComponent } from "./navigation/navigation.component";
import { UserPermissionGuard } from "./t2-workspace/guard/user-permission.guard";

const routes: Routes = [
  {
    path: 'workspace',
    loadChildren: () =>
      import('./t1-workspace/t1-workspace.module').then(
        (m) => m.T1WorkspaceModule
      ),
  },
  {
    path: 't2-workspace',
    loadChildren: () =>
      import('./t2-workspace/t2-workspace.module').then(
        (m) => m.T2WorkspaceModule
      ),
    canActivate: [LoggedInGuard, UserPermissionGuard],
  },
  {
    path: 'auth-terms-disclosure',
    component: AuthInterceptorPage,
    canActivate: [mapToCanActivate([AuthInterceptorGuard])],
  },
  {
    path: 'sign-terms-of-use',
    loadChildren: () => import('./terms-of-use-sign/terms-of-use.module').then(m => m.TermsOfUsePageModule)
   // canActivate: [LoggedInGuard]
  },
  {
    path: '',
    component: ComponentsComponent,
    canActivate: [LoggedInGuard],
    children: [
      {
        path: 'email-settings',
        title: 'Email Settings',
        loadChildren: () =>
          import('./components/email-settings/email-settings.module').then(
            (m) => m.EmailSettingsModule
          )
      },

      {
        path: 'downloads',
        title: 'Large Downloads',
        loadChildren: () =>
          import('./components/downloads/downloads.module').then(
            (m) => m.DownloadsModule
          )
      },
      {
        path: 'feeds',
        loadChildren: () =>
          import('./components/feeds/feeds.module').then(
            (m) => m.FeedsModule
          ),
        canActivate: mapToCanActivate([FeedsGuard])
      },
      {
        path: 'account-details',
        title: 'Account Details',
        loadChildren: () =>
          import('./components/account-details/account-details.module').then(
            (m) => m.AccountDetailsModule
          )
      },
      {
        path: 'terms-of-use',
        title: 'Terms of Use',
        loadChildren: () =>
          import('./components/terms-of-use/terms-of-use.module').then(
            (m) => m.TermsOfUseReferenceModule
          )
      },
      {
        path: 'following',
        title: 'Followed Records',
        pathMatch: 'full',
        loadChildren: () =>
          import('./components/following/following.module').then(
            (m) => m.FollowingModule
          )
      },
      {
        path: 'roles',
        component: NavigationComponent,
        data: { navigatedFor: 'access' },
        canActivate: mapToCanActivate([NavigatedFor]),
      },
    ],
  },
  {
    path: 'role-management',
    canActivate: [LoggedInGuard],
    loadChildren: () => import('./user-directory/user-directory.module').then(m => m.UserDirectoryModule),
  },
  {
    path: '**',
    title: 'Followed Records',
    redirectTo: '/'
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
  providers: []
})
export class AppRoutesModule { }
